import { Lock } from "lucide-react";

/**
 * AnonymityBanner — a persistent, calming reassurance strip shown
 * on every triage screen. Reinforces the "we don't know who you are"
 * promise to reduce resident anxiety and build trust.
 *
 * Variant "compact" is for inside question flows (slim bar).
 * Variant "full" is a slightly larger version for result pages.
 */
export default function AnonymityBanner({ variant = "compact" }) {
  if (variant === "full") {
    return (
      <div
        className="bg-[#F3F8F5] border border-[#00703C] border-opacity-20 rounded-md p-4 flex items-start gap-3 mb-6"
        data-testid="anonymity-banner-full"
      >
        <Lock size={18} className="text-[#00703C] mt-0.5 flex-shrink-0" />
        <div className="text-sm text-gray-700">
          <p className="font-medium text-[#00703C] mb-0.5">Your answers stay with you.</p>
          <p>
            We don't save your name, address, or identity. This Guidance Checker is designed only to
            give you clear, confidential advice — so you can feel confident about your next step.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex items-center justify-center gap-2 py-2 px-4 bg-[#F3F8F5] border border-[#00703C] border-opacity-15 rounded-md text-xs text-gray-700 mb-4"
      data-testid="anonymity-banner"
    >
      <Lock size={14} className="text-[#00703C]" />
      <span>
        <span className="font-medium text-[#00703C]">Anonymous &amp; confidential.</span>{" "}
        We don't save your name, address, or identity.
      </span>
    </div>
  );
}
